var isSearched = false;

var buscador = {
    datepicker: function () {
        if (typeof mobiscroll != "undefined") {
            var min = new Date();
            var myRange = mobiscroll.datepicker('#dates', {
                controls: ['calendar'],
                select: 'range',
                dateFormat: 'DD/MM/YYYY',
                touchUi: true,
                showRangeLabels: false,
                locale: mobiscroll.localeEs,
                min: min,
                minRange: 1,
                responsive: {
                    xsmall: {
                        display: 'center',
                        pages: 1,
                        touchUi: true
                    },
                    medium: {
                        display: 'center',
                        pages: 2,
                        touchUi: true
                    },
                    custom: { // Custom breakpoint
                        breakpoint: 850,
                        display: 'center',
                        pages: 2,
                        touchUi: false
                    }
                },
                onChange: function (event, inst) {
                    var dates = inst._valueText.split(" - ");
                    var idgetawayksdate = null;
                    if (dates.length == 2) {
                        // Offer
                        var i = dates[0].split("/")
                        var o = dates[1].split("/")
                        var dateIn = i[2] + '-' + i[1] + '-' + i[0];
                        var dateOut = o[2] + '-' + o[1] + '-' + o[0];
                        var idgetawaysdate = "";
                        if($("input[name='idgetawaysdate'").length) {
                            idgetawayksdate = $("input[name='idgetawaysdate'").val();
                        }
                        buscador.getOffer(dateIn, dateOut, idgetawaysdate);
                        $('#dates').removeClass('border-danger');
                        $(".alert-date").addClass('hidden');
                    }
                },
                onInit: function (event, inst) {}
            });

            // var dates = $("#dates").val().split(" - ");
            // if (dates.length == 2) {
            //     var fechaIni = moment(dates[0], "DD/MM/YYYY");
            //     var fechaFin = moment(dates[1], "DD/MM/YYYY");
            //     myRange.setVal([fechaIni, fechaFin]); // set

            //     // Offer
            //     var i = dates[0].split("/")
            //     var o = dates[1].split("/")
            //     var dateIn = i[2] + '-' + i[1] + '-' + i[0];
            //     var dateOut = o[2] + '-' + o[1] + '-' + o[0];
            //     buscador.getOffer(dateIn, dateOut);
            // }
        }
    },
    rooms: function () {
        // Render
        buscador.bindingRenderSelects();



        // Add
        $('.btn--add').off('click').on('click', function (e) {
            e.preventDefault();

            let title = '';
            let roomsNumber = $('.habitacion').length;
            switch (roomsNumber) {
                case 1:
                    title = 'Segunda habitación';
                    break;

                case 2:
                    title = 'Tercera habitación';
                    break;

                case 3:
                    title = 'Cuarta habitación';
                    break;

                default:
                    break;
            }

            var newRoom = $('.habitacion:last').clone();
            newRoom.find('.adult option:eq(1)').prop('selected', true);
            newRoom.find('.child option:eq(0)').prop('selected', true);
            newRoom.find('.child option').show();
            newRoom.find('.age1').removeClass('border-danger').find('option:eq(0)').prop('selected', true);
            newRoom.find('.age2').removeClass('border-danger').find('option:eq(0)').prop('selected', true);
            newRoom.find('.alert-age').addClass('hidden');
            newRoom.insertAfter('.habitacion:last');
            $('.title-hab:last').html(title);

            $([document.documentElement, document.body]).animate({
                scrollTop: $('.habitacion:last').offset().top
            }, 900);

            buscador.bindingRoomsAddDel();
        });
        // Del
        $('.btn--del').off('click').on('click', function (e) {
            e.preventDefault();
            $('.habitacion:last').slideUp("fast", function () {
                $(this).remove();
                buscador.bindingRoomsAddDel();
            });
        });
        // OnChange
        $('.child').off('change').on('change', function (e) {
            buscador.bindingRenderSelects();
        });
        $('.adult').off('change').on('change', function (e) {
            buscador.bindingRenderSelects();
        });
    },
    getOffer: function (dateIn, dateOut, idgetawaysdate) { // yyyy-mm-dd
        if(idgetawaysdate.length === 0) {
            $.post("/buscador/offer/", {
                dateIn: dateIn,
                dateOut: dateOut
            }, function (data) {
                if (data.isOffer == true) {
                    $(".section-offer").removeClass('d-none');
                } else {
                    $(".section-offer").addClass('d-none');
                }
            }, "json").fail(function () {
                $(".section-offer").addClass('d-none');
            });
        } else {
            $.post("/buscador/getaway/", {
                dateIn: dateIn,
                dateOut: dateOut,
                idGetawaysDate: idgetawaysdate
            }, function (data) {
                if (data.isGetaway == true) {
                    $(".section-getaway").removeClass('d-none');
                } else {
                    $(".section-getaway").addClass('d-none');
                }
            }, "json").fail(function () {
                $(".section-getaway").addClass('d-none');
            });
        }
    },
    bindingRenderSelects: function () {
        let childValue;
        let age1;
        let age2;
        $('.habitacion').each(function () {
            var $this = $(this);
            buscador.agesRooms($this);
            buscador.moreFourPeopleRooms($this);
        });
    },
    isSelectedAges: function ($this, onlyOnVisible = false) {
        var age1 = $this.find('.age1');
        var age2 = $this.find('.age2');
        var isKO = false;

        if( age1.is(':visible') && age1.val() == "" ) {
            isKO = true;
            age1.addClass('border-danger');
            if(onlyOnVisible) {
                $this.find('.alert-age').removeClass("hidden");
            }
        } else {
            age1.removeClass('border-danger');
        }

        if( age2.is(':visible') && age2.val() == "" ) {
            isKO = true;
            age2.addClass('border-danger');
            if(onlyOnVisible) {
                $this.find('.alert-age').removeClass("hidden");
            }
        } else {
            age2.removeClass('border-danger');
        }

        if (!isKO) {
            $this.find('.alert-age').addClass("hidden");
        }

        return isKO;

    },
    moreFourPeopleRooms: function($this) {
        // Alerts cuando supera los 4 personas
        var adultValue = $this.find('.adult').val();
        var childValue = $this.find('.child').val();
        if((parseInt(childValue) + parseInt(adultValue)) > 4) {
            $this.find('.alert-maxpeople').removeClass("hidden");
            return true;
        } else {
            $this.find('.alert-maxpeople').addClass("hidden");
            return false;
        }
    },
    agesRooms: function($this) {
        var childValue = $this.find('.child').val();
        var age1 = $this.find('.age1');
        var age2 = $this.find('.age2');
        //
        switch (childValue) {
            case "0":
                age1.hide();
                age2.hide();
                break;

            case "1":
                age1.show();
                age2.hide();
                break;

            case "2":
                age1.show();
                age2.show();
                break;

            default:
                age1.hide();
                age2.hide();
                break;
        }
    },
    bindingRoomsAddDel: function () {
        let roomsNumber = $('.habitacion').length;
        switch (roomsNumber) {
            case 1:
                $('.btn--add').removeClass('d-none'); // can add
                $('.btn--groups').addClass('d-none'); // cant add
                $('.btn--del').addClass('d-none'); // cant del
                // Titles more one
                $('.title-hab').addClass('d-none');
                break;

            case 4:
                $('.btn--add').addClass('d-none'); // cant add
                $('.btn--groups').removeClass('d-none'); // cant add
                $('.btn--del').removeClass('d-none'); // can del
                // Titles more one
                $('.title-hab').removeClass('d-none');
                break;

            default:
                $('.btn--add').removeClass('d-none'); // can add
                $('.btn--groups').addClass('d-none'); // cant add
                $('.btn--del').removeClass('d-none'); // can del
                // Titles more one
                $('.title-hab').removeClass('d-none');
                break;
        }
        buscador.rooms();
    },
    init: function () {
        if ($('.buscador').length > 0 || $('.formulario-grupos').length > 0) {
            buscador.datepicker();
            buscador.rooms();

            $('.btn-search').off('click').on('click', function(e){
                e.preventDefault();

                isSearched = true;
                var isKO = false;
                $('.habitacion').each(function () {
                    var $this = $(this);
                    isKO = isKO ||= buscador.moreFourPeopleRooms($this);
                    isKO = isKO ||= buscador.isSelectedAges($this, isSearched);

                    $this.find('.age1, .age2').off('change').on('change', function (e) {
                        buscador.isSelectedAges($this, isSearched);
                    });
                });

                if($('#dates').val() == "") {
                    isKO = true;
                    $('#dates').addClass('border-danger');
                    $('.alert-date').removeClass("hidden");
                } else {
                    $('.alert-date').addClass("hidden");
                }

                if(!isKO) {
                    $('.buscador').submit();
                }
            });
        }
    }
}

var resultados = {
    init: function () {
        $('#customSwitch1').off('change').on('change', function (e) {
            resultados.bindingSwitchNR();
        });
        resultados.bindingSwitchNR();
    },
    bindingSwitchNR: function () {
        if ($('#customSwitch1').prop('checked')) {
            $('.normal').addClass('d-none');
            $('.noreem').removeClass('d-none');
        } else {
            $('.normal').removeClass('d-none');
            $('.noreem').addClass('d-none');
        }
    }
};

$(function () {
    var locationHref = $(location).attr('href');
    var anchor = locationHref.split("#");

    if(anchor.length > 1 && anchor[1] == "otras-fechas" && $("#otras-fechas").length > 0) {
        $("a[href='#accordion-dates']").trigger("click");
    }

    // PROMO CODE
    $(".add-promocode").off('click').on('click', function (e) {
        e.preventDefault();
        $(".promo-box").removeClass('d-none');
        $(".add-promocode").addClass('d-none');
        $(".del-promocode").removeClass('d-none');
    });

    $(".del-promocode").off('click').on('click', function (e) {
        e.preventDefault();
        $(".promo-box").addClass('d-none');
        $(".add-promocode").removeClass('d-none');
        $(".del-promocode").addClass('d-none');
        $(".promo-box input").val("");
    });

    // ANIMACIONES ON SCROLL --> gsap
    gsap.registerPlugin(ScrollTrigger);

    //ANIMACION SOBRE EL BOTON GRANDE REDONDO - RESERVAR
    if ($(".btn-circle--anim").length > 0) {
        let tlHome = gsap.timeline({});

        tlHome.to(".btn-circle--anim", {
            rotation: 30,
            scale: 1.2,
            scrollTrigger: {
                trigger: "#reservar--circle",
                start: "top center",
                toggleActions: "play pause reverse pause",
                scrub: 1,
            }
        })
    }

    if ($(".svg-star").length > 0) {
        let tlOfertas = gsap.timeline({});

        //ANIMACION ESTRELLA EN OFERTAS
        tlOfertas.to(".svg-star", {
            rotation: 720,
            scale: 1.5,
            scrollTrigger: {
                trigger: "#ofertas--2",
                // start: "top center",
                toggleActions: "play pause reverse pause",
                scrub: 2,
            },
        })
    }

    // DESCRIPCIÓN EN MODAL FOTOS
    $(".fotos-item img").off("click").on("click", function (e) {
        e.preventDefault();
        if ($(this).next().is(':visible')) {
            $(this).next().fadeOut();
        } else {
            $(this).next().fadeIn();
        }
    });


    // Esto evita que al cerrar un modal se quede el foco en el boton que lo abre.
    $('.swiper-container .button').on('focus', function () {
        $(this).blur();
    });

    // Lazy Loading Images
    (async () => {
        if ("loading" in HTMLImageElement.prototype) {
            // Si el navegador soporta lazy-load, tomamos todas las imágenes que tienen la clase
            // `lazyload`, obtenemos el valor de su atributo `data-src` y lo inyectamos en el `src`.
            const images = document.querySelectorAll("img.lazyload");
            images.forEach((img) => {
                img.src = img.dataset.src;
            });
        } else {
            // Importamos dinámicamente la libreria `lazysizes`
            const lazySizesLib = await import("/assets/js/lazysizes.min.js");
            // Se inicia lazysizes (lee el atributo `data-src` y la clase `lazyload`)
            lazySizes.init();
        }
    })();

    buscador.init();
    resultados.init();

    $(".sms-location").off('submit').on('submit', function (e) {
        e.preventDefault();

        var elem$ = $(this);
        var action = elem$.attr('action');
        var phoneNumber = elem$.find('input[name=phone_number]').val();
        var token = elem$.find('input[name=token]').val();

        var txtSended = 'Enviado ✓';

        $.get(action + '?phone_number=' + phoneNumber + '&token=' + token, function(data){
            if(data.ok == false) {
                alert(data.errors);
                return;
            }
            elem$.find('button').html(txtSended);
            // elem$.find('input[name=phone_number]').val("");
            $('.sms-ok').toggle();
            // location.reload();
        }, 'json').fail(function () {
            alert('Ha ocurrido algún error, intentelo mas tarde');
        });

    });


    // Compartir por whatsapp resultados
    $(".shared_whatsapp").off("click").on("click", function (e) {
        e.preventDefault();

        if($(this).attr("href") == "#") {
            $.post("/buscar/generateyourls/", {'url':window.location.href}, function (data) {
                if (!data.isOK) {
                    console.log(data.error);
                    return false;
                }

                var url = $(".shared_whatsapp").data("href") + data.url;
                $(".shared_whatsapp").attr("href", url);
                window.open(url, '_blank');

            }, 'json').fail(function () {
                console.log("error inesperado");
            });
        } else {
            var url = $(this).attr("href");
            window.open(url, '_blank');
        }
    });

    $('#noflexible-accordion-guardar-presupuesto-form, #flexible-accordion-guardar-presupuesto-form').off('submit').on('submit', function (e){
        e.preventDefault();

        var $el = $(this);

        $.post($el.attr('action'), {
            'name': $el.find("input[name='name']").val(),
            'email': $el.find("input[name='email']").val()
        }, function (data) {
            $el.find("input[name='name']").val('');
            $el.find("input[name='email']").val('');
            $el.find(".alert-ok").show();
        }, 'json').fail(function () {
            alert('se ha producido algun error al enviar el presupuesto');
        });
    });
    //SCROLL TO ??

    // gsap.utils.toArray("nav a").forEach(function (a) {
    //     a.addEventListener("click", function (e) {
    //         e.preventDefault();
    //         gsap.to(window, {
    //             duration: 1,
    //             scrollTo: e.target.getAttribute("href")
    //         });
    //     });
    // });


    //SCROLL TO TOP
    //https://codepen.io/petebarr/pen/qBOeVoz

    // function scrollTop() {
    //     gsap.to(window, {
    //         duration: 2,
    //         scrollTo: {
    //             y: "#slide-0"
    //         },
    //         ease: "power2.inOut"
    //     });
    //     gsap.to('.footer__link-top-line', {
    //         scaleY: 1,
    //         transformOrigin: "bottom center",
    //         duration: 0.6,
    //         ease: "power4"
    //     });
    // }

});
